// extracted by mini-css-extract-plugin
export default {"list_item":"style_list_item__v1aX-"};